import _omit from 'lodash/omit';
import APPCONFIG from '../../constants/Config';
import { REGISTER_DEVICE_CMD } from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.deviceCmd;
const deviceCmd = (state = initialSettings, action) => {
  switch (action.type) {
    // REGISTER
    case REGISTER_DEVICE_CMD:
      return {
        ...state,
        list: [...state.list, _omit(action, 'type')],
      };
    default:
      return state;
  }
};

export default deviceCmd;



// WEBPACK FOOTER //
// ./reducers/device/deviceCmd.js